import {
  THEME_SET,
  THEME_TOGGLE,
  THEME_STORAGE_KEY,
} from "../constants/themeConstants";

/**
 * Set the theme explicitly to "light" or "dark".
 * Persists the choice to localStorage so it survives page reloads.
 */
export const setTheme = (mode) => (dispatch) => {
  const safe = mode === "dark" ? "dark" : "light";
  try {
    localStorage.setItem(THEME_STORAGE_KEY, safe);
  } catch {
    /* private mode / quota — ignore, in-memory state still works */
  }
  dispatch({ type: THEME_SET, payload: safe });
};

/**
 * Flip the current theme. Reads current value from state so the action
 * stays a single dispatch — no need for the caller to know the mode.
 */
export const toggleTheme = () => (dispatch, getState) => {
  const current = getState().theme?.mode === "dark" ? "dark" : "light";
  const next = current === "dark" ? "light" : "dark";
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  dispatch({ type: THEME_TOGGLE, payload: next });
};
